/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Suspense } from 'react';
import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';
import { ConnectedRouter } from 'connected-react-router';
import { PersistGate } from 'redux-persist/integration/react';
import { Amplify } from 'aws-amplify';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import AuthService from 'Services/auth';
import { store, persistor, history } from 'Store';
import { sagaMiddleware } from 'Store/middlewares';
import initSagas from 'Store/sagas';
import App from 'Components/App';
import SplashLoader from 'Components/UI/SplashLoader';
import { paypalOptions } from 'Config/paypal';
import config from './aws-exports';
import { QueryClientProvider } from './query-manager';

Amplify.configure(config);
AuthService.authListener();
initSagas(sagaMiddleware);

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <Suspense fallback={<SplashLoader />}>
        <QueryClientProvider>
          <ConnectedRouter history={history}>
            <PayPalScriptProvider options={paypalOptions}>
              <App />
            </PayPalScriptProvider>
          </ConnectedRouter>
        </QueryClientProvider>
      </Suspense>
    </PersistGate>
  </Provider>
);
